export default __webpack_public_path__ + "static/media/changeNameFile.dbe9da96.svg";